module.exports = "https://img1.huilianyi.com/5/search@3x.5acd64fae8.appcore.png";